import React from "react";
import { Helmet } from "react-helmet";

const Disclaimer = () => {
  return (
    <>
      <Helmet>
        <title>Disclaimer — AI Cyber Assistant</title>
        <meta
          name="description"
          content="AI Cyber Assistant Disclaimer — Understand the terms and conditions of using our cybersecurity tools."
        />
      </Helmet>

      <div className="container mx-auto p-6 md:p-12">
        <h1 className="text-3xl font-bold mb-6 text-center">Disclaimer</h1>
        <p className="mb-4">
          The information provided by AI Cyber Assistant is for general
          informational purposes only. All tools, scans, and results are provided
          “as is” without any warranty.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Accuracy of Information</h2>
        <p>
          While we strive to keep all data accurate and up to date, we do not
          guarantee the completeness, reliability, or accuracy of results
          generated by automated scans.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">External Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for the content or privacy practices of such sites.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Limitation of Liability</h2>
        <p>
          AI Cyber Assistant and its creators are not liable for any losses or
          damages arising from the use of our services, data, or tools.
        </p>

        <p className="mt-6">
          By using our platform, you agree to this disclaimer and our Privacy
          Policy.
        </p>
      </div>
    </>
  );
};

export default Disclaimer;
